import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { FinancialBenefitListItem } from '@services/member/list/financial-benefits/financial-benefits.types';
import { FinancialBenefit } from '@services/member/member/member.types';
import { useGetFinancialBenefitsMutation } from '@services/member/list/financial-benefits/financial-benefits.endpoints';

export const useFinancialBenefitEditionPageVM = () => {

    const [totalFinancialBenefits, setTotalFinancialBenefits] = useState<number>(0);
    const [financialBenefitsItems, setFinancialBenefitsItems] = useState<FinancialBenefitListItem[]>([]);
    const columnHelper = createColumnHelper<FinancialBenefit>();

    const navigate = useNavigate();

    const [getFinancialBenefitsItems, { isSuccess: isGetFinancialBenefitsSuccess, isLoading: isGetFinancialBenefitsLoading, data: financialBenefitsData }] =
    useGetFinancialBenefitsMutation();

    useEffect(() => {
        getFinancialBenefitsItems(undefined);
    }, []);

    useEffect(() => {
        if (isGetFinancialBenefitsLoading) return;
        if (isGetFinancialBenefitsSuccess && financialBenefitsData) {
            setFinancialBenefitsItems(financialBenefitsData.data);
        }
    }, [isGetFinancialBenefitsSuccess]);

       const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalFinancialBenefits(metadata.total);
        }
    };

    return {
        handleMetadata,
        navigate,
        columnHelper,
        financialBenefitsItems,
        totalFinancialBenefits
    };
};
